export default "__VITE_ASSET__CpzyNhSm__"